import { render } from "./AddUsersInClass.vue?vue&type=template&id=1762abe8&scoped=true"
import script from "./AddUsersInClass.vue?vue&type=script&lang=js"
export * from "./AddUsersInClass.vue?vue&type=script&lang=js"

import "./AddUsersInClass.vue?vue&type=style&index=0&id=1762abe8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1762abe8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QImg,QTooltip,QSelect,QItem,QItemSection,QCheckbox});
